import { PatientCell as PatientTableCell } from '@equip.health/ui';
import { useHistory } from 'react-router-dom';

import { InquiryEvents } from '~/analytics';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import {
  PortalComponent,
  useComponentPortalContext,
} from '~/lib/contexts/ComponentPortalContext';
import { getPreferredFullName } from '~/lib/util/patient.util';
import { Path } from '~/routes/constants';

const PatientCell = ({
  patient,
  inquiryId,
}: {
  patient: InquiryListItemResponse['patient'];
  inquiryId: string;
}) => {
  const history = useHistory();
  const {
    firstName: patientFirstName,
    lastName: patientLastName,
    chosenName: patientChosenName,
    dateOfBirth,
  } = patient;

  const { trackEvent } = useAnalytics();

  const trackInquiryDetailDrawerEvent = (name: InquiryEvents) =>
    trackEvent(name, { Source: 'Inquiry List' });

  const { setComponentVisibility } = useComponentPortalContext();

  const handleCloseInquiryDetailDrawer = () => {
    history.push(Path.MAUD_INQUIRIES);
    setComponentVisibility({
      component: PortalComponent.INQUIRY_DETAIL_DRAWER,
      data: null,
      isVisible: false,
    });
    trackInquiryDetailDrawerEvent(InquiryEvents.detailClosed);
  };

  const handlePatientClick = () => {
    history.push(`?id=${inquiryId}`);
    setComponentVisibility({
      component: PortalComponent.INQUIRY_DETAIL_DRAWER,
      data: { inquiryId, onClose: handleCloseInquiryDetailDrawer },
      isVisible: true,
    });
    trackInquiryDetailDrawerEvent(InquiryEvents.detailOpened);
  };

  return (
    <PatientTableCell
      id={`inquiry-${inquiryId}`}
      onClick={handlePatientClick}
      patient={{
        dob: dateOfBirth ? new Date(dateOfBirth) : null,
        name: getPreferredFullName(
          patientChosenName,
          patientFirstName,
          patientLastName,
          false,
        ),
      }}
    />
  );
};
export default PatientCell;
